import { LicenseWebPageResponse } from 'commons/types/DTO/bank/license/LicenseWebPageResponse'
import { SymbolBadge } from 'ui/components/Badges'
import { getIconFile } from 'ui/components/Icon/getIconFile'
import { IconName } from 'ui/components/Link'

import { s } from './styles'

export const CRBMonitorInfo = ({
  showCRBConnectionMark,
  showCRBConnectionStatus
}: Pick<LicenseWebPageResponse, 'showCRBConnectionMark' | 'showCRBConnectionStatus'>) => {
  const file = getIconFile(IconName.LARGE_CRB_MONITOR)

  return (
    <s.Container>
      <i dangerouslySetInnerHTML={{ __html: file }} />
      <s.Label>
        {showCRBConnectionMark === 'success' && <SymbolBadge color="positive" icon={IconName.CHECK_ROUND} />}{' '}
        {showCRBConnectionMark === 'warning' && <SymbolBadge color="warning" icon={IconName.INFO_ROUND} />}{' '}
        {showCRBConnectionMark === 'danger' && <SymbolBadge color="error" icon={IconName.INFO_ROUND} />}
        {showCRBConnectionStatus}
      </s.Label>
    </s.Container>
  )
}
